import moment from "moment";
import AsyncCallHandler from "../common/AsyncCallHandler";
import NEXUS_CONST from "../common/constants";
import ACTION_TYPES from "./actionTypes";

export const fetchSurveyQuestionData = (dispatch, surveyId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_QUESTIONS_SURVEY + surveyId,
    NEXUS_CONST.GET
  ).then((res) => {
    // fetchPeopleList(dispatch, tier);
    dispatch({ type: ACTION_TYPES.FETCH_QUESTIONARE_DATA, payload: res.data });
  });
};

export const fetchMultiSurveyIDBySurveyData = (
  dispatch,
  tierId,
  surveyData
) => {
  AsyncCallHandler(
    `MultiSurvey/getMultiSurveyIDBySurveyData?tierID=${tierId}&surveyData=${surveyData}`,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_MULTI_SURVEY_DATA_BY_SURVEY_FILTER,
      payload: res.data[0],
    });
  });
};

export const manageSurveyQuestionsData = (dispatch, data, surveyId) => {
  AsyncCallHandler(
    NEXUS_CONST.MANAGE_SURVEY_QUESTIONS_DATA,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    if (res) {
      fetchSurveyQuestionData(dispatch, surveyId);
    }
  });
};

export const fetchMultiSurveyShiftData = (
  dispatch,
  tierId,
  surveyDate,
  surveyId
) => {
  AsyncCallHandler(
    `MultiSurvey/getMultiSurveyShiftData?tierID=${tierId}&surveyDate=${surveyDate}&surveyID=${surveyId}`,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_MULTI_SURVEY_SHIFT_DATA,
      payload: res.data,
    });
  });
};

export const fetchShiftSurveyQuestionData = (
  dispatch,
  clsSurveyQuestionData
) => {
  AsyncCallHandler(
    `MultiSurvey/getMultiSurveyQuestionData`,
    NEXUS_CONST.POST,
    clsSurveyQuestionData
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_MULTI_SURVEY_SHIFT_QUESTION_DATA,
      payload: res.data,
    });
  });
};

export const manageShiftSurveyQuestionsData = (dispatch, data) => {
  AsyncCallHandler(
    `MultiSurvey/manageMultiSurveyShiftQuestionData`,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    if (res) {
      fetchSurveyQuestionData(dispatch, data.surveyID);
      dispatch({
        type: ACTION_TYPES.REFRESH_MULTI_SURVEY_WIDGET,
        payload: res.data,
      });
    }
  });
};

export const exportMultiSurveyData = (payload) => {
  const name = payload.isAll
    ? `survey-all`
    : `survey_${payload.startDate}_to_${payload.endDate}`;

  AsyncCallHandler(
    `MultiSurvey/exportMultiSurveyData`, //?tierId=${payload.tierId}&startDate=${payload.startDate}&endDate=${payload.endDate}&isAll=${payload.isAll}`,
    NEXUS_CONST.POST,
    payload,
    NEXUS_CONST.BLOB
  ).then((res) => {
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name + ".xlsx");
    document.body.appendChild(link);
    link.click();
  });
};
export const getParetoChartData = (dispatch, data) => {
  AsyncCallHandler(
    `MultiSurvey/GetSurveyMissQuestionBySurveyId`,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    if (res.data) {
      dispatch({
        type: ACTION_TYPES.FETCH_MULTI_SURVEY_PARETO_CHART_DATA,
        payload: res.data,
      });
    }
  });
};
export const getRunChartData = (dispatch, data) => {
  AsyncCallHandler(
    `MultiSurvey/MSRunChart?TierId=${data.tierId}&SurveyID=${data.surveyId}&Date=${data.date}`,
    NEXUS_CONST.GET
  ).then((res) => {
    if (res.data) {
      dispatch({
        type: ACTION_TYPES.FETCH_MULTI_SURVEY_RUN_CHART_DATA,
        payload: res.data,
      });
    }
  });
};
